export default __webpack_public_path__ + "static/media/1.36a9d434.jpg";